export { SplitStepLayout as OnboardStepLayout } from "~/components/split-step-layout";
